import { Component, ElementRef, Host, HostListener, Input, OnDestroy, ViewEncapsulation } from '@angular/core';

import { DropdownComponent } from './dropdown.component';
import { Type, DropdownDirection } from './constants';

@Component({
    selector: 'fc-dropdown-toggle',
    host: { class: 'fc-dropdown-toggle' },
    templateUrl: './dropdown-toggle.component.html',
    styleUrls: ['./dropdown-toggle.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DropdownToggleComponent implements OnDestroy {
    @Input() public type: Type;
    @Input() public disabled: boolean;
    @Input() public direction: DropdownDirection;

    private closeDropdownOnOutsideClick: (event: Event) => void;

    constructor(
        @Host() private dropdown: DropdownComponent,
        private elementRef: ElementRef
    ) {
        this.disabled = false;

        this.closeDropdownOnOutsideClick = (event: MouseEvent) => {
            const nativeElement = this.elementRef.nativeElement;
            if (event.target !== nativeElement && !nativeElement.contains(event.target)) {
                this.close();
            }
        };
    }

    get typeName() {
        return this.type || Type.Default;
    }

    get dropdownDirection() {
        return this.direction || DropdownDirection.Down;
    }

    @HostListener('click')
    toggle() {
        if (this.dropdown.isOpened()) {
            this.doClose();
        } else {
            this.doOpen();
        }
    }

    open() {
        if (!this.dropdown.isOpened()) {
            this.doOpen();
        }
    }

    close() {
        if (this.dropdown.isOpened()) {
            this.doClose();
        }
    }

    ngOnDestroy() {
        this.unregisterListener();
    }

    private doOpen() {
        this.dropdown.open();
        document.addEventListener('click', this.closeDropdownOnOutsideClick, false);
    }

    private doClose() {
        this.dropdown.close();
        this.unregisterListener();
    }

    private unregisterListener() {
        document.removeEventListener('click', this.closeDropdownOnOutsideClick, false);
    }
}
